var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsApp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    "data-prefix": "i7cpoj09k",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "1WhatsApp.svg",
    d: "M8.14.005a7.79 7.79 0 0 0-6.73 11.814L0 16l4.35-1.381A7.811 7.811 0 1 0 8.14.005zm0 1.3A6.525 6.525 0 0 0 1.6 7.791a6.44 6.44 0 0 0 1.25 3.8l-.82 2.408 2.52-.8A6.505 6.505 0 1 0 8.14 1.31zm4.06 8.5a.9.9 0 0 0-.37-.246c-.2-.107-1.17-.625-1.35-.7a.309.309 0 0 0-.45.083c-.14.194-.55.627-.67.756a.3.3 0 0 1-.43.033 5.425 5.425 0 0 1-1.58-1.047 5.859 5.859 0 0 1-1.06-1.419.291.291 0 0 1 .1-.4c.09-.086.21-.225.31-.337a1.192 1.192 0 0 0 .22-.324.358.358 0 0 0-.01-.349c-.04-.1-.41-1.095-.56-1.5s-.32-.344-.44-.349-.25-.026-.38-.031a.755.755 0 0 0-.55.229 2.242 2.242 0 0 0-.76 1.633 3.87 3.87 0 0 0 .74 2.087 8.207 8.207 0 0 0 3.31 3.13c2.01.872 2.02.606 2.39.587a2.018 2.018 0 0 0 1.39-.9 1.565 1.565 0 0 0 .15-.928z",
    fillRule: "evenodd",
    className: "path-iggct64da"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsApp);
export default __webpack_public_path__ + "static/media/whatsApp.3ebe95168e99a884d571a8071202d7ba.svg";
export { ForwardRef as ReactComponent };